// AI-ASSISTED: generated with claude-code on 2026-06-10, reviewed by Yoann Hertienne
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';

export { StorybookCard } from './StorybookCard';

const storybookCard = EntityCardBlueprint.make({
  name: 'storybook',
  params: {
    filter: 'kind:component',
    loader: async () => {
      const { StorybookCard } = await import('./StorybookCard');
      return <StorybookCard />;
    },
  },
});

export const storybookCardModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [storybookCard],
});
